import { RedoCarrierName } from "@redotech/redo-model/carrier-account/carrier-account";

export function getFilteredCarrierOptions({
  carrierOptions,
  checkoutOptimizationEnabled = false,
  newOmsEnabled = false,
}: {
  carrierOptions: RedoCarrierName[];
  checkoutOptimizationEnabled?: boolean;
  newOmsEnabled?: boolean;
}): RedoCarrierName[] {
  const filteredForOms = carrierOptions.filter(
    (carrier) =>
      carrier !== RedoCarrierName.USPS && carrier !== RedoCarrierName.USPS_SHIP,
  );
  const filteredForReturns = carrierOptions.filter(
    (carrier) => carrier !== RedoCarrierName.USPS_DIRECT,
  );

  const filtered =
    newOmsEnabled || checkoutOptimizationEnabled
      ? filteredForOms
      : filteredForReturns;

  return filtered.sort((a, b) => a.localeCompare(b));
}
